import WebApiService from "@/services/webapi.service.js";
import Unita from "@/models/unita.model.js";

const state ={
    unita: []
}

const getters = {
 
    getUnita: (state) => {
        return state.unita;
    },

    getDescrizioneUnita: (state) => (codiceUnita) => {
        if(state.unita){
            let unita =  state.unita.find(item => item.CodiceUnita === codiceUnita);

            if(unita){
                return sito.DescrizioneUnita ?? "-";
            }
            else{
                return "-";
            }
        }
        else{
            return "-";
        }
    }
}

const mutations = {
    setUnita: (state, unita) => {
        state.unita = unita;      
    }
}

const actions = {

    getUnita: ({commit}, data) => {                                                                                                              
        return WebApiService.get('unita/GetUnita', data.token).then(
        (data) => {              
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }
                else{                  
                    commit("setUnita", data.Data.map(
                        o => { return Object.assign(new Unita(), o) }
                    ));
                    return [true, ""];            
                }
            },
            error => {                      
                return [false, ""];
            }
        )
        .catch(
            error => {return [false, ""]}
        );
    }
}

export default{
    namespeced:true,
    state,
    getters,
    mutations,
    actions
}



